<template>
  <div class="" v-bind:class="{
    'main-button-wrapper': true,
    'button-size-small': size === 'small',
    'button-size-medium': size === 'medium',
    'button-size-large': size === 'large',
    'button-size-medium-large': size === 'medium-large',
    'button-theme-solid-blue': theme === 'solid-blue',
    'button-theme-outline-white': theme === 'outline-white',
    'button-theme-solid-white': theme === 'solid-white',
    'button-theme-solid-brown': theme === 'solid-brown',
    'button-theme-solid-white-brown': theme === 'solid-white-brown',

  }" @mouseout="hover=false"
       @mouseover="hover=true"
  >
    <div class="d-flex justify-content-center align-items-center">
      <div v-if="icon" class="icons-container me-2">
        <CalendarIcon v-if="icon === 'calendar'"/>
        <FilterIconBrown v-if="icon === 'filter'" class="brown-icon"/>
        <FilterIconWhite v-if="icon === 'filter'" class="white-icon"/>
      </div>
      <div> {{ buttonText }}</div>
      <div v-if="icon" class="icons-container ms-auto">
        <ArrowForwardIcon v-if="icon === 'arrow-forward' || hover" :arrow-color="'white'"/>
        <ArrowForwardIcon v-if="icon === 'arrow-forward-blue' && !hover" :arrow-color="'blue'"/>
      </div>
    </div>


  </div>
</template>

<script>
import ArrowForwardIcon from "@/components/Common/Icons/ArrowForwardIcon.vue";
import CalendarIcon from "@/components/Common/Icons/CalendarIcon.vue";
import FilterIconBrown from "@/components/Common/Icons/FilterIconBrown.vue";
import FilterIconWhite from "@/components/Common/Icons/FilterIconWhite.vue";

export default {
  name: "MainButton",
  components: {FilterIconWhite, FilterIconBrown, CalendarIcon, ArrowForwardIcon},
  props: {
    buttonText: {
      type: String
    },
    theme: {
      type: String
    },
    size: {
      type: String
    },
    icon: {
      type: String
    }
  },
  data() {
    return {
      hover: false
    }
  }
}
</script>

<style lang="scss" scoped>
.main-button-wrapper {

  border-radius: 30px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  font-size: 10px;
  font-family: $font-bold;
  text-align: center;

  &:hover {
    transition: 0.3s ease-in-out;
  }
}

.button-theme-solid-blue {
  background: $color-blue-accent;
  color: $color-white;

  &:hover {
    color: $color-white;
    background: $color-blue-secondary;
  }
}

.button-theme-solid-white {
  background: $color-white;
  color: $color-dark-brown;

  &:hover {
    color: $color-white;
    background: $color-blue-secondary;
  }
}

.button-theme-solid-brown {
  background: $color-cta-main;
  color: $color-white;

  &:hover {
    color: $color-white;
    background: $color-brown;
  }
}

.button-theme-solid-white-brown {
  background: $color-white;
  color: $color-brown;

  .white-icon {
    display: none;
  }


  &:hover {
    color: $color-white;
    background: $color-cta-main;

    .white-icon {
      display: block;
    }

    .brown-icon {
      display: none;
    }
  }
}

.button-theme-outline-white {
  box-shadow: inset 0 0 0 2px $color-white;
  color: $color-white;

  &:hover {
    color: $color-white;
    background: $color-blue-accent;
    box-shadow: none;
  }
}

.button-size-large {
  font-size: 15px;
  padding: 15px;
  border-radius: 50px;
}

.button-size-small {
  font-size: 10px;
  padding: 10px 15px;
}

.button-size-medium {
  font-size: 13px;
  padding: 12px;
}

.button-size-medium-large {
  font-size: 16px;
  padding: 18px 35px;
  border-radius: 50px;
}


@media screen and (min-width: 768px) {

}
</style>
